module.exports = __webpack_public_path__ + "media/images/pic/hero/flowers-817e541fa5cf88083e35cc2212cca6b2.webp";